import type { History } from 'history'

/** Replace current history location with all entries of initialEntries from item 0 through item initialIndex.  */
export default function resetStack(history: History, initialEntries: string[], initialIndex: number): void {
  if (initialIndex > 0) {
    history.replace(initialEntries[0])
    for (let currentIndex = 1; currentIndex <= initialIndex; currentIndex++) {
      history.push(initialEntries[currentIndex])
    }
  } else {
    history.replace(initialEntries[initialIndex])
  }
}
